import { ProblemResults } from '@yandex-int/k-common/typings';
// @ts-ignore
import formatTime from '@yandex-int/k-common/utils/format-time';
import { Text } from 'platform-components';
import React from 'react';

import { StatItem } from '../lesson-content__stat-item-wrapper';

export const TeamTime = (props: { lessonProblemResult: ProblemResults; isEvaluated: boolean }) => {
    const { lessonProblemResult, isEvaluated } = props;
    const value = isEvaluated ? formatTime(lessonProblemResult?.details?.medianTime) : null;

    return (
        <StatItem>
            <Text id="studentLessonStat.classTime" />
            <span className="lesson-content__stat-detail-value">
                <Text weight={Text.WEIGHT.L}>{value || <>&mdash;</>}</Text>
            </span>
        </StatItem>
    );
};
